<div class="container card mt-2 ">
    <div class="container">

            <h4 class="text-left" i18n="@@orderInformation">Order Information </h4>
            <ul>
                <li>
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col-12">
                                                                    <span class="pull-left">
                                    <i style="font-size: 30px;color:#444;" class="fa fa-cube text-left"></i>

                                </span>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Order#:</b> {{order[0]?.entity_id}}</div>
                            </div>

                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Order Date:</b> {{order[0]?.created_at}}</div>
                            </div>


                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Items count:</b> {{order[0]?.total_item_count}}
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Order
                                    Total: </b>{{order[0]?.total_due}} {{order[0]?.base_currency_code}} </div>
                            </div>

                        </div>
                    </div>


                </li>
            </ul>

    </div>


    <div class="container">

                <h4 class="text-left">Order Items </h4>
                <ul>
                    <li *ngFor="let item of order[0]?.items ; let i = index">
                        <div class="row">
                            <div class="col-12">
                                <div class="col-1 pull-left">
                                    <img src="{{Products[i]?.getImage()}}" class="img-fluid" alt="...">
                                </div>

                                <div class="col-11 pull-right">
                                    <div class="row">
                                        <div class="col-12">

                                            <div class="row">
                                                <div class="col-12 text-left"><b i18n>Name:</b> {{item.name}}</div>
                                            </div>

                                            <div class="row">
                                                <div class="col-12 text-left"><b i18n>Price:</b> {{item.price}}</div>
                                            </div>


                                            <div class="row">
                                                <div class="col-12 text-left"><b i18n>Items
                                                    count:</b>  {{item.qty_ordered}}</div>
                                            </div>

                                            <div class="row">
                                                <div class="col-12 text-left"><b i18n>Order
                                                    Total: </b>{{item.row_total}} </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-12 text-right">
                                                    <button class="btn btn-primary"
                                                            (click)="goToProductDetails(item.sku)"
                                                            style="padding-right: 20px ; padding-left: 20px"> Details
                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </li>
                </ul>

    </div>


    <div class="container  ">

        <h4 class="text-left">Shipping Address </h4>
        <div class="">

            <div class="addresses_list">
                <div class="address_line">
                    <div class="cont">
                        <div class="row ">
                            <div class="col-12">
                                        <span class="name text-left">{{order[0]?.billing_address.firstname}}
                                            ,  {{order[0]?.billing_address.lastname}}</span>
                                <div style="color:#888;"><i
                                        class="fa fa-globe text-left"> </i> {{order[0]?.billing_address.city}}
                                    , {{order[0]?.billing_address.country_id}}
                                </div>
                                <div style="color:#888;"><i
                                        class="fa fa-phone text-left"> </i> {{order[0]?.billing_address.telephone}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
